export default __webpack_public_path__ + "static/media/nlp1.dd75faeb.png";